module.exports = __webpack_public_path__ + "static/media/cursor-pointer.337be4c7.svg";